import { IHttpApi } from '@cian/http-api/shared';
import { IBuilderSuggest } from '../types/builder';
import {
  fetchGetBuilderSuggests,
  IGetBuilderSuggestsRequest,
  TGetBuilderSuggestsResponse,
} from '../repositories/countryside-search/v1/get-builder-suggests';

export async function getBuilderSuggests(httpApi: IHttpApi, parameters: IGetBuilderSuggestsRequest) {
  const { response, statusCode } = await fetchGetBuilderSuggests<
    TGetBuilderSuggestsResponse,
    TGetBuilderSuggestsResponse
  >({
    httpApi,
    parameters,
  });

  if (statusCode !== 200 || 'errors' in response) {
    throw response;
  }

  return response.suggests as IBuilderSuggest[];
}
